import { __extends, __assign } from 'tslib';
import React__default from 'react';
import { tabPropTypes, tabDefaultProps } from './Tabs.types.js';
import styles from './Tabs.module.scss.js';

var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onTabClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, disabled = _a.disabled;
            if (onClick && !disabled) {
                onClick(e);
            }
        };
        return _this;
    }
    Tab.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, isActive = _a.isActive, disabled = _a.disabled, testId = _a.testId;
        return (React__default.createElement("div", { className: styles.Tab + " " + (isActive ? styles.Tab___selected : '') + " " + (disabled ? styles.Tab___disabled : '') + " " + (className || ''), onClick: this.onTabClick, "data-testid": testId },
            React__default.createElement("div", { className: styles["Tab_label" + (isActive ? '___selected' : '')] }, children)));
    };
    Tab.propTypes = tabPropTypes;
    Tab.defaultProps = __assign({}, tabDefaultProps);
    Tab.displayName = 'Tabs.Tab';
    return Tab;
}(React__default.Component));

export default Tab;
export { Tab };
